import { ImageHelper } from '@/lib/helpers/image.helper'

const img = (path: string) => ImageHelper.getImageUrl(path)

export const AN_TRUONG_IMAGES = {
  hero: {
    desktop: img('/image/2026/11/04/desk.jpg'),
    mobile: img('/image/2026/11/04/mobi.jpg'),
  },
  story: {
    videoPlaceholder: img('/image/2026/11/04/AT_Video.jpg'),
  },
  products: {
    ecc: {
      main: img('/image/2026/11/04/Main.jpg'),
      detail: img('/image/2026/11/04/Detail.jpg'),
      wear: img('/image/2026/11/04/Wear.jpg'),
    },
    excool: {
      main: img('/image/2026/11/04/Main_37.jpg'),
      detail: img('/image/2026/11/04/Detail_66.jpg'),
      wear: img('/image/2026/11/04/Wear_12.jpg'),
    },
    relaxed: {
      main: img('/image/2026/11/04/Main_88.jpg'),
      detail: img('/image/2026/11/04/Detail_9.jpg'),
      wear: img('/image/2026/11/04/Wear_52.jpg'),
    },
  },
} as const

export interface PainChipConfig {
  key: 'ecc' | 'excool' | 'relaxed'
  targetId: string
}

export const PAIN_CHIPS: readonly PainChipConfig[] = [
  { key: 'ecc', targetId: 'ecc-pants' },
  { key: 'excool', targetId: 'kaki-excool' },
  { key: 'relaxed', targetId: 'relaxed-straight-jeans' },
] as const

export interface ProductItemConfig {
  key: 'ecc' | 'excool' | 'relaxed'
  id: string
  reverse?: boolean
  href: string
  hasDiscount?: boolean
  images: {
    main: string
    detail: string
    wear: string
  }
}

export const AN_TRUONG_PRODUCTS: readonly ProductItemConfig[] = [
  {
    key: 'ecc',
    id: 'ecc-pants',
    reverse: false,
    href: '/product/quan-dai-nam-ecc-ripstop-pants?color=xanh-navy',
    hasDiscount: true,
    images: AN_TRUONG_IMAGES.products.ecc,
  },
  {
    key: 'excool',
    id: 'kaki-excool',
    reverse: true,
    href: '/product/quan-dai-kaki-excool-co-gian?color=xam-den',
    hasDiscount: true,
    images: AN_TRUONG_IMAGES.products.excool,
  },
  {
    key: 'relaxed',
    id: 'relaxed-straight-jeans',
    reverse: false,
    href: '/product/quan-jeans-nam-relaxed-dang-straight',
    hasDiscount: false,
    images: AN_TRUONG_IMAGES.products.relaxed,
  },
] as const

export interface ChooserCardConfig {
  key: 'ecc' | 'excool' | 'relaxed'
  href: string
}

export const CHOOSER_CARDS: readonly ChooserCardConfig[] = [
  {
    key: 'ecc',
    href: '/product/quan-dai-nam-ecc-ripstop-pants?color=xanh-navy',
  },
  {
    key: 'excool',
    href: '/product/quan-dai-kaki-excool-co-gian?color=xam-den',
  },
  {
    key: 'relaxed',
    href: '/product/quan-jeans-nam-dang-suong-relaxed-straight-jeans',
  },
] as const
